import {
    message,
    Spin,
    Row,
    Col,
    Select,
    Space,
    Popconfirm,
    PageHeader,
    Tooltip,
} from "antd";
import React, { Component } from "react";
import {
    Form,
    FormItem,
    InputNumberItem,
    SelectItem,
    round2Decimals,
    round6Decimals,
    dineroDisabledMask,
    ModalItem,
    DatePickerItem,
    InputItem,
    ButtonItem,
    NotificacionMovimientosInventario,
    DisponibilidadInsumoModal,
    HistorialInsumoClienteModal,
    DetalleInsumoModal,
} from "../../../../Components/Items";
import moment from "moment";
import axios from "axios";
import { connect } from "react-redux";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { SendOutlined, CommentOutlined, FileTextOutlined, FileExcelOutlined, EyeOutlined } from "@ant-design/icons";
import { descargarExcelDocumento } from "../../../../Components/DescargarDocumentosMasivo";
import GenerarVentaDeEmbarque from "../GenerarVentaDeEmbarque/GenerarVentaDeEmbarque";
import MandarCorreoEmbarque from "../MandarCorreoEmbarque/MandarCorreoEmbarque";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import IconAd2 from "../../../../Icons/IconAd2";
import RastrearRequisicion from "../../Ventas/RastrearRequisicion/RastrearRequisicion";
import TrazabilidadSteps from "../../Ventas/TrazabilidadSteps/TrazabilidadSteps";
import VentasForm from "../../../../Components/VentasForm";
import TabEntregaDireccion from "../../../../Components/TabEntregaDireccion";
import BotonDescripcionLarga, { textoDescripcionLarga, imprimeDescripcionLarga } from "../../../../Components/BotonDescripcionLarga";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

class VerEmbarque extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        descargandoExcel: false,
        objetoClientes: null,
        todasClientes: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoPrecios: null,
        todasPrecios: null,
        objetoInsumos: null,
        todasInsumos: [],
        objetoUsosDeCFDI: null,
        todasUsosDeCFDI: null,
        objetoBancos: null,
        todasBancos: null,
        objetoUsuarios: null,
        todasUsuarios: null,
        objetoMonedas: null,
        todasMonedas: null,
        impuestos: [],
        modalConfirmacion: false,
        modalCorreo: false,
        modalCorreoId: null,
        modalElegirTipoDeCliente: false,
        modalElegirTipoDeClienteNombre: null,
        modalElegirTipoDeClienteId: null,
        valuesForm: null,
        entregarInsumos: false,
        total: 0,
        subtotal: 0,
        arrayImpuestos: [],
        arrayRetenciones: [],
        totalPagar: 0,
        venderSinInventario: false,
        id: this.props.location.state.id,
        modalGenerarVenta: false,
        requerido: false,
        numeroEmbarque: "",
        direccionesCliente: [],
        objetoDireccionesCliente: null,
        todasPaises: [],
        todasEstado: [],
        todasMunicipios: [],
        todasColonias: [],
        objetoPaises: null,
        objetoEstados: null,
        objetoMunicipios: null,
        objetoColonias: null,
        loadingEntrega: false,
        addendaMabe: false,
        loadingPlantasEntrega: false,
        apartado: false,
        anticipos: false,
        modalRastrearRequisicion: false,
        trace: null,
        tiposDescuento: {},
        modalDisponibilidadVisible: false,
        insumoSeleccionadoDisponibilidad: { id: null, nombre: '' },
        modalHistorialClienteVisible: false,
        insumoSeleccionadoHistorial: { id: null, nombre: '', clienteId: null, index: 0 },
        modalDetalleInsumoVisible: false,
        insumoSeleccionadoDetalle: { id: null, nombre: '' },
        totalCantidadInsumos: 0,
    };

    abrirDisponibilidad = (insumoId, nombre, proyectoId) => {
        this.setState({
            modalDisponibilidadVisible: true,
            insumoSeleccionadoDisponibilidad: { id: insumoId, nombre, proyectoId }
        });
    }

    cerrarDisponibilidad = () => {
        this.setState({ modalDisponibilidadVisible: false });
    }

    abrirDetalleInsumo = (insumoId, nombre) => {
        if (!insumoId) return;
        this.setState({ modalDetalleInsumoVisible: true, insumoSeleccionadoDetalle: { id: insumoId, nombre } });
    }

    cerrarDetalleInsumo = () => {
        this.setState({ modalDetalleInsumoVisible: false });
    }

    // Clic derecho en la misma celda donde el doble clic abre Disponibilidad. Pantalla de solo
    // lectura: no se pasa permitirUsarPrecio.
    abrirHistorialCliente = (insumoId, nombre, index) => {
        if (!insumoId) return message.warning("Primero selecciona un insumo en el renglón");
        const clienteId = this.formRef.current?.getFieldValue("clienteId");
        if (!clienteId) return message.warning("Primero selecciona un cliente para ver su historial");
        this.setState({
            modalHistorialClienteVisible: true,
            insumoSeleccionadoHistorial: { id: insumoId, nombre, clienteId, index },
        });
    }

    cerrarHistorialCliente = () => {
        this.setState({ modalHistorialClienteVisible: false });
    }

    componentDidMount() {
        this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "embarques/selectDatosParaEmbarque",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data.proyectos,
                        todasPrecios: res.data.precios,
                        todasUsosDeCFDI: res.data.usosDeCFDI,
                        todasUsuarios: res.data.usuariosEmpresa,
                        todasMonedas: res.data.monedas,
                        venderSinInventario: res.data.venderSinInventario,
                        objetoProyectos: res.data.proyectos.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoPrecios: res.data.precios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoUsosDeCFDI: res.data.usosDeCFDI.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value?.c_UsoCFDI + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                        objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre +
                                        " " +
                                        value.apellidoPaterno +
                                        " " +
                                        value.apellidoMaterno}
                                </Option>
                            );
                        }),
                        objetoMonedas: res.data.monedas.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviacion}
                                </Option>
                            );
                        }),
                        
                    });
                }
            });

        if (this.props.equipoMedico) {

            await axios
                .post(
                    "ventas/selectDatosParaEquipoMedico",
                    { empresaId: this.props.empresaId },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.success === 2) {
                        this.setState({
                            todasDoctores: res.data.doctores,
                            todasPacientes: res.data.pacientes,
                            todasCirugias: res.data.cirugias,
                            objetoDoctores: res.data.doctores.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoPacientes: res.data.pacientes.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                            objetoCirugias: res.data.cirugias.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.codigo + ' - ' + value.nombre}
                                    </Option>
                                );
                            }),
                        });
                    } else {
                        message.error('No se encontraron datos de equipo medico')
                    }
                });

        }

        await axios
            .post(
                "embarques/datosEmbarque",
                { empresaId: this.props.empresaId, embarqueId: this.state.id },
                { headers: this.props.headersToken }
            )
            .then(async (res) => {
                if (res.data.status === 404) {
                    message.error("Error no se encontro informacion del embarque");
                } else {
                    const responseCliente = await axios.post("clientes/buscarCliente", {
                        clienteId: res.data.clienteId,
                        empresaId: this.props.empresaId
                    }, { headers: this.props.headersToken });
                    if (responseCliente.data.success === 2) {
                        this.setState({
                            direccionesCliente: responseCliente.data.cliente.direcciones || [],
                        });
                    }
                    this.formRef.current.setFieldsValue({
                        ...res.data,
                        factura: res.data.factura ? 1 : 2,
                        fechaEntregaEstimada: res.data.fechaEntregaEstimada
                            ? moment(res.data.fechaEntregaEstimada)
                            : undefined,
                        fechaPedido: res.data.fechaPedido
                            ? moment(res.data.fechaPedido)
                            : moment(res.data.createdAt),
                        fechaVigencia: res.data.fechaVigencia
                            ? moment(res.data.fechaVigencia)
                            : undefined,
                        insumos: res.data.insumos.map((insumo) => {
                            const precioUnitarioConImpuestos =
                                insumo.precioUnitario + insumo.impuestos / insumo.cantidad;
                            const pendiente = insumo.cantidad - (insumo.vendido || 0)
                            return { ...insumo, precioUnitarioConImpuestos, pendiente };
                        }),
                    });
                    const insumosAgregarTodos = res.data.insumosCatalogo || [];
                    
                    if (insumosAgregarTodos.length === 0 && res.data?.insumos?.length > 0) {
                        return message.error('No se pudieron obtener todos los insumos del embarque');
                    }
                    
                    const tiposDescuentoIniciales = {};
                    (res.data.insumos || []).forEach((insumo, index) => {
                        if (insumo.descuentoCantidad && insumo.descuentoCantidad > 0) {
                            tiposDescuentoIniciales[index] = 'cantidad';
                        } else {
                            tiposDescuentoIniciales[index] = 'porcentaje';
                        }
                    });

                    this.setState({ tiposDescuento: tiposDescuentoIniciales, todasInsumos: insumosAgregarTodos,});
                    this.setState({
                        estado: res.data.estado,
                        factura: res.data.factura,
                        nombrePedido: 'Pedido: ' + res.data.numero,
                        requerido: res.data.requerido,
                        remision: res.data.remision,
                        total: res.data.total,
                        subtotal: res.data.subtotal,
                        arrayImpuestos: res.data.arrayImpuestos,
                        totalPagar: res.data.totalPagar,
                        apartado: res.data.apartado,
                        arrayRetenciones: res.data.arrayRetenciones,
                        numeroEmbarque: res.data.embarqueSerie + ' - ' + res.data.embarqueNumero,
                        anticipos: res.data.anticipos || false,
                        trace: res.data.trace || null,
                        totalCantidadInsumos: (res.data.insumos || []).reduce(
                            (suma, insumo) => suma + (Number(insumo.cantidad) || 0),
                            0
                        ),
                    });
                    if (res?.data?.direccionEntrega?.plantaEntregaId) {
                        this.setState({ addendaMabe: true });
                    } else {
                        this.setState({ addendaMabe: false });
                    }
                }
            });
        this.setState({ loading: false });
    }
    atras() {
        this.props.history.goBack();
    }
    async onChangeInsumoProyecto(value, key, tipo) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let precioId = await this.formRef.current.getFieldValue("precioId");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        let proyectoId = arrayValue[key].proyectoId;
        const insumoId = arrayValue[key].insumoId;
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === insumoId
        );
        // if(tipo === 'insumo'){
        //   function getAllIndexes(arr, val) {
        //     var indexes = [], i = -1;
        //     while ((i = arr.indexOf(val, i+1)) != -1){
        //         indexes.push(i);
        //     }
        //     return indexes;
        // }
        // }
        if (!insumo) return;
        if (insumo.inventariable || insumo.insumoCompuesto) {
            await axios
                .post(
                    "inventarios/inventarioInsumoProyecto",
                    {
                        proyectoId: proyectoId,
                        insumoId: insumoId,
                        noPrincipal: insumo.noPrincipal,
                        insumoCompuesto: insumo.insumoCompuesto,
                        empresaId: this.props.empresaId,
                    },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    this.setState({ loading: false });
                    arrayValue[key].cantidadProyecto = res.data.cantidad;
                });
        } else {
            arrayValue[key].cantidadProyecto = "No inventariable";
        }
        const precio = insumo.precios.find(
            (valuePrecios) => valuePrecios.precioId?.toString() === precioId
        );
        if (precio) {
            arrayValue[key].precioUnitario = precio.precio;
        } else {
            message.info("Este insumo no tiene ese precio");
            arrayValue[key].precioUnitario = 0;
        }

        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );

        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })

                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    async onChangePrecioCantidadDescuento(value, key) {
        let arrayValue = await this.formRef.current.getFieldValue("insumos");
        let clienteId = await this.formRef.current.getFieldValue("clienteId");
        let tipoDeCambio = await this.formRef.current.getFieldValue("tipoDeCambio");
        const insumo = this.state.todasInsumos.find(
            (valueInsumos) => valueInsumos._id === arrayValue[key].insumoId
        );
        if (!insumo) return;
        const precioUnitario = Number(arrayValue[key].precioUnitario)

        let totalImpuestosPrecioSinImpuestos = 0;
        insumo.impuestos.map((valueImpuesto) => {
            let totalImpuesto;
            if (valueImpuesto.tasaCuota === 1) {
                totalImpuesto = precioUnitario * (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 2) {
                totalImpuesto =
                    (precioUnitario + totalImpuestosPrecioSinImpuestos) *
                    (valueImpuesto.monto / 100);
            } else if (valueImpuesto.tasaCuota === 3) {
                totalImpuesto = (valueImpuesto.monto / tipoDeCambio);
            } else if (valueImpuesto.tasaCuota === 5) {
                totalImpuesto = 0
            }
            totalImpuestosPrecioSinImpuestos += totalImpuesto;
            return null;
        });
        arrayValue[key].precioUnitarioConImpuestos = round2Decimals(
            precioUnitario + totalImpuestosPrecioSinImpuestos
        );
        const cantidad = arrayValue[key].cantidad;
        const descuento = arrayValue[key].descuento || 0;

        if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
            //1
            const subtotal = round6Decimals(cantidad * precioUnitario);
            //2
            const totalDescuento = round6Decimals(subtotal * (descuento / 100));
            //3
            const totalEntrada = round6Decimals(subtotal - totalDescuento);
            arrayValue[key].subtotal = totalEntrada;

            let totalImpuestos = 0;
            let arrayImpuestos = insumo.impuestos.map(
                //4
                (valueImpuesto) => {
                    let totalImpuesto;
                    let baseImpuesto;
                    let montoImpuesto;
                    if (valueImpuesto.tasaCuota === 1) {
                        totalImpuesto = round6Decimals(
                            totalEntrada * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = totalEntrada
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 2) {
                        totalImpuesto = round6Decimals(
                            (totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100)
                        );
                        baseImpuesto = (totalEntrada + totalImpuestos)
                        montoImpuesto = round6Decimals(valueImpuesto.monto / 100)
                    } else if (valueImpuesto.tasaCuota === 3) {
                        totalImpuesto = round6Decimals((cantidad * valueImpuesto.monto) / tipoDeCambio);
                        baseImpuesto = cantidad
                        montoImpuesto = round6Decimals(valueImpuesto.monto / tipoDeCambio)
                    } else if (valueImpuesto.tasaCuota === 5) {
                        totalImpuesto = 0
                        baseImpuesto = totalEntrada
                        montoImpuesto = 0
                    }
                    totalImpuestos += totalImpuesto;
                    return {
                        tasaCuota: valueImpuesto.tasaCuota,
                        impuesto: valueImpuesto.impuesto,
                        montoImpuesto: montoImpuesto,
                        local: valueImpuesto.local,
                        baseImpuesto: baseImpuesto,
                        descripcionFactura: valueImpuesto.descripcionFactura,
                        totalImpuestos: totalImpuesto,
                    };
                }
            );
            arrayValue[key].impuestos = totalImpuestos;
            arrayValue[key].arrayImpuestos = arrayImpuestos;
            //5
            arrayValue[key].total = round2Decimals(
                arrayValue[key].subtotal + totalImpuestos
            );

            if (clienteId) {
                //Consultar cliente

                const cliente = this.state.todasClientes.find(
                    (valueP) => valueP._id === clienteId
                );
                //6
                let totalRetenciones = 0;
                let arrayRetenciones = []
                cliente.retenciones.map((valueRetencion) => {
                    //7
                    let totalRetencion;
                    let baseRetencion;
                    if (valueRetencion.tasaCuota === 1) {
                        totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                        baseRetencion = totalEntrada
                    } else if (valueRetencion.tasaCuota === 2) {
                        totalRetencion =
                            round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                        baseRetencion = (totalEntrada + totalImpuestos)
                    }
                    totalRetenciones += totalRetencion;
                    arrayRetenciones.push({
                        tasaCuota: valueRetencion.tasaCuota,
                        impuesto: valueRetencion.impuesto,
                        montoRetencion: valueRetencion.monto,
                        local: valueRetencion.local,
                        baseRetencion: baseRetencion,
                        descripcionFactura: valueRetencion.descripcionFactura,
                        totalRetenciones: totalRetencion,
                    });
                    return null
                })
                insumo.retenciones.map((valueRetencion) => {
                    if ((valueRetencion.aplicaVenta === 1 && cliente.persona === false) || (valueRetencion.aplicaVenta === 2 && cliente.persona === true) || valueRetencion.aplicaVenta === 3) {
                        //7
                        let totalRetencion;
                        let baseRetencion;
                        if (valueRetencion.tasaCuota === 1) {
                            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
                            baseRetencion = totalEntrada
                        } else if (valueRetencion.tasaCuota === 2) {
                            totalRetencion =
                                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
                            baseRetencion = (totalEntrada + totalImpuestos)
                        }
                        totalRetenciones += totalRetencion;
                        arrayRetenciones.push({
                            tasaCuota: valueRetencion.tasaCuota,
                            impuesto: valueRetencion.impuesto,
                            montoRetencion: valueRetencion.monto,
                            local: valueRetencion.local,
                            baseRetencion: baseRetencion,
                            descripcionFactura: valueRetencion.descripcionFactura,
                            totalRetenciones: totalRetencion,
                        });
                    }
                    return null
                })
                arrayValue[key].retenciones = totalRetenciones;
                arrayValue[key].arrayRetenciones = arrayRetenciones;
            }

        }
        this.formRef.current.setFieldsValue({
            insumos: arrayValue,
        });
    }
    onChangeCliente(valueId) {
        const contado = this.formRef.current.getFieldValue("contado");
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === valueId
        );
        if (!cliente.regimenFiscalId || !cliente.direcciones[0]?.coloniaId) {
            message.info('No se podra facturar a este cliente. Faltan datos')
        }
        if (!cliente.tipoClienteId) {
            const nombre = cliente.persona
                ? cliente.razonSocial
                : `${cliente.nombre} ${cliente.apellidoPaterno} ${cliente.apellidoMaterno}`;
            this.abrirElegirTipoDeCliente(cliente._id, nombre);
        }
        let objetoCambiar = {}
        if (cliente.usoDeCFDIID) {
            objetoCambiar.usoDeCfdiId = cliente.usoDeCFDIID
        }
        if (cliente.precioContadoId || cliente.precioCreditoId) {
            objetoCambiar.precioId = contado === 1 ? cliente.precioContadoId : cliente.precioCreditoId
        }
        if (cliente.proyectoId) {
            objetoCambiar.proyectoId = cliente.proyectoId
        }
        this.setState({
            complementoDetallista: cliente.complementoDetallista,
            detallista: {
                orderIdentification: cliente.orderIdentification,
                referenceDateOrderIdentification: cliente.referenceDateOrderIdentification,
                additionalInformation: cliente.additionalInformation,
                deliveryNote: cliente.deliveryNote,
                referenceDateDeliveryNote: cliente.referenceDateDeliveryNote,
            }
        })
        this.formRef.current.setFieldsValue({
            diasCredito: cliente.diasCredito || 0,
            ...objetoCambiar
        });
        this.setState({ addendaMabe: cliente.addendaMabe || false });

    }
    onChangeContado(value) {
        const clienteId = this.formRef.current.getFieldValue("clienteId");
        if (!clienteId) return;
        const cliente = this.state.todasClientes.find(
            (valueProv) => valueProv._id === clienteId
        );
        this.formRef.current.setFieldsValue({
            precioId: value === 1 ? cliente.precioContadoId : cliente.precioCreditoId,
        });
    }
    cerrarMandarCorreoEmbarque() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
    }
    enviarPedido(value) {
        this.setState({ modalCorreo: true, modalCorreoId: value });
    }

    async descargarExcel() {
        this.setState({ descargandoExcel: true });
        await descargarExcelDocumento({
            modulo: "embarque",
            id: this.state.id,
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
        });
        this.setState({ descargandoExcel: false });
    }

    generarVentaDePedido() {
        this.setState({ modalGenerarVenta: true });
    }

    cerrarGenerarVentaDeEmbarque() {
        this.setState({
            modalGenerarVenta: false,
        });
        this.consultarTodo();
    }

    cancelarEmbarque(value) {
        this.setState({ loading: true });
        axios
            .post(
                "embarques/cancelarEmbarque",
                { embarqueId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Embarque cancelado");
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                    this.consultarTodo();
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
            });
    }

    requerirInsumos() {
        this.props.history.push('/panel/requerirInsumosPedido', { pedidoId: this.state.id });
    }

    apartarInsumos() {
        this.props.history.push('/panel/apartarInsumosPedido', { pedidoId: this.state.id });
    }

    async onChangeEstado(value, inicial) {
        if (!inicial) {
            this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    municipioId: undefined,
                    coloniaId: undefined
                }
            });
        }
        await axios
            .post(
                "municipios/selectMunicipios",
                { estadoId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoMunicipios = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasMunicipios: res.data,
                        objetoMunicipios: objetoMunicipios,
                    });
                }
            });
    }

    async onChangeMunicipio(value, inicial) {
        await axios
            .post(
                "colonias/selectColonias",
                { municipioId: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    let objetoColonias = res.data.map((value) => {
                        return (
                            <Option value={value._id} key={value._id}>
                                {value.cp + " - " + value.nombre}
                            </Option>
                        );
                    });
                    this.setState({
                        todasColonias: res.data,
                        objetoColonias: objetoColonias,
                    });
                }
            });
    }


    async onSearchColonia(value) {
        if (value.toString().length === 5) {
            await axios
                .post(
                    "colonias/buscarCP",
                    { cp: value },
                    {
                        headers: this.props.headersToken,
                    }
                )
                .then((res) => {
                    if (res.data.status === 404) {
                        message.info("No se encontro el codigo postal");
                    } else {
                        this.formRef.current.setFieldsValue({
                            direccionEntrega: {
                                paisId: res.data.paisId,
                                estadoId: res.data.estadoId,
                                municipioId: res.data.municipioId
                            }
                        });
                        this.onChangeEstado(res.data.estadoId, true);
                        this.onChangeMunicipio(res.data.municipioId, true);
                    }
                });
        }
    }
    async onSelectColoniaId(coloniaId, fieldKey) {
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");
        if (!direccionEntrega?.colonia) {
            const nombreColonia = this.state.todasColonias.find((todasColonia) => todasColonia._id.toString() === coloniaId.toString())?.nombre
            await this.formRef.current.setFieldsValue({
                direccionEntrega: {
                    colonia: nombreColonia
                }
            })
        }
    }

    async handleChangeDireccionEntrega(value) {
        this.setState({ loadingEntrega: true })
        if (value) {
            const direccion = this.state.direccionesCliente.find((direccion) => direccion._id.toString() === value.toString())
            if (direccion) {
                if (direccion.estadoId) {
                    await this.onChangeEstado(direccion.estadoId, true);
                }
                if (direccion.municipioId) {
                    await this.onChangeMunicipio(direccion.municipioId, true);
                }
                if (direccion.plantaEntregaId) {
                    await this.onSearchPlantaEntrega(direccion.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
                }
                this.formRef.current.setFieldsValue({
                    direccionEntrega: {
                        paisId: direccion.paisId,
                        estadoId: direccion.estadoId,
                        municipioId: direccion.municipioId,
                        coloniaId: direccion.coloniaId,
                        colonia: direccion.colonia,
                        calle: direccion.calle,
                        numeroCalle: direccion.numeroCalle,
                        numeroInterior: direccion.numeroInterior,
                        descripcion: direccion.descripcion,
                        telefono: direccion.telefono,
                        correo: direccion.correo,
                        observaciones: direccion.observaciones, plantaEntregaId: direccion.plantaEntregaId,
                        referencia: direccion.referencia,
                    }
                })
            }
        }
        this.setState({ loadingEntrega: false })
    }

    consultarInformacionEntrega() {
        if (this.state.todasPaises.length > 0) return
        this.setState({ loadingEntrega: true })
        const direccionEntrega = this.formRef.current.getFieldValue("direccionEntrega");

        if (direccionEntrega?.plantaEntregaId && this.state.addendaMabe) {
            this.onSearchPlantaEntrega(direccionEntrega?.plantaEntregaId, "direccionEntrega", { byId: true, setSelected: false });
        }
        axios.post("direcciones/selectInformacionDomicilio", { direccion: direccionEntrega }, {
            headers: this.props.headersToken
        })
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loadingEntrega: false,
                        todasPaises: res.data.paises,
                        todasEstado: res.data.estados,
                        todasMunicipios: res.data.municipios,
                        todasColonias: res.data.colonias,
                        objetoMunicipios: res.data.municipios.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                        objetoColonias: res.data.colonias.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.cp + " - " + value.nombre}
                                </Option>
                            );
                        }),
                        objetoPaises: res.data.paises.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                        objetoEstados: res.data.estados.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.abreviatura}
                                </Option>
                            );
                        }),
                    })
                } else {
                    message.info("No se encontró información para entrega")
                    this.setState({
                        loadingEntrega: false
                    })
                }
            })
    }
    onSearchPlantaEntrega = async (value, fieldKey, opts = {}) => {
        const { byId = false, setSelected = false } = opts;
        if (byId) {
            await axios
                .post(
                    "plantaDeEntrega/selectPlantaEntregaPorId",
                    { id: value },
                    { headers: this.props.headersToken }
                )
                .then((res) => {
                    const p = res?.data?.dato || null;
                    if (!p || !p._id) {
                        this.setState(prev => ({
                            objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                        }));
                        message.warning("No se encontró la planta por ID.");
                        return;
                    }

                    const option = (
                        <Option key={p._id} value={p._id} padre={p.plantaEntregaId}>
                            {p.label}
                        </Option>
                    );

                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [option] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));

                    if (setSelected && (this.props.form?.setFieldsValue || this.form?.setFieldsValue)) {
                        const form = this.props.form || this.form;
                        form.setFields([
                            { name: ['"direccionEntrega"', fieldKey, 'plantaEntregaId'], value: p._id }
                        ]);
                    }
                })
                .catch((err) => {
                    console.error(err);
                    message.error("Error al buscar planta por ID");
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                });

            return;
        }
        this.setState(prev => ({
            loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: true }
        }));
        await axios
            .post(
                "plantaDeEntrega/selectPlantasDeEntrega",
                {
                    query: value || ""
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res?.data.success !== 2) {
                    this.setState(prev => ({
                        objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                        loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                    }));
                    return;
                }
                const items = Array.isArray(res.data.plantas) ? res.data.plantas : [];
                const options = items.map(it => (
                    <Option key={it._id} value={it._id} padre={it.plantaEntregaId}>
                        {it.label}
                    </Option>
                ));

                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: options },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            })
            .catch((err) => {
                console.error(err);
                message.error("Error al buscar plantas de entrega");
                this.setState(prev => ({
                    objetoPlantasEntrega: { ...prev.objetoPlantasEntrega, [fieldKey]: [] },
                    loadingPlantasEntrega: { ...prev.loadingPlantasEntrega, [fieldKey]: false }
                }));
            });
    }

    desapartarInsumos() {
        this.setState({ loading: true });
        axios
            .post(
                "pedidos/desapartarInsumos",
                { pedidoId: this.state.id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Insumos quitados de apartado");
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                    this.consultarTodo();
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudieron quitar de apartados los insumos");
                }
            });
    }

    generarAnticipo() {
        this.props.history.push("/panel/agregarVenta", { anticipo: true, embarqueId: this.state.id });
    }

    cerrarRastrearRequisicion() {
        this.consultarTodo();
        this.setState({
            modalRastrearRequisicion: false,
        });
    }

    getInsumosColumns() {
        return [
            { title: "Insumo", width: "16%" },
            { title: "Unidad", width: "6%" },
            { title: "Proyecto", width: "9%" },
            { title: "PU", width: "8%" },
            { title: "Precio Neto", width: "8%" },
            { title: "Inventario", width: "6%" },
            {
                title: (
                    <>
                        <div>Cant.</div>
                        <div style={{ fontWeight: 400, fontSize: '11px', color: '#868585' }}>
                            Total: {this.state.totalCantidadInsumos}
                        </div>
                    </>
                ),
                width: "6%",
            },
            { title: "Pendiente", width: "6%" },
            { title: "Desc.", width: "7%" },
            { title: "Subtotal / Impuesto / Total", width: "14%" },
            { title: "", width: "8%" }
        ];
    }

    renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove }) {
        return (
            <React.Fragment key={key}>
                <tr className="fila-insumo">
                    <td className="td-border" style={{ maxWidth: '200px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        <FormItem {...restField} name={[name, "insumoId"]} required noStyle>
                            <SelectItem
                                sinBorde
                                disabled
                                noDisabledBackground
                                width="100%"
                                placeholder="Insumo"
                                style={{ boxShadow: 'none', whiteSpace: 'normal', wordBreak: 'break-word', height: 'auto', minHeight: '32px'}}
                            >
                                {this.state.todasInsumos?.map(insumo => {
                                    let displayText = insumo.stringBuscar || (insumo.codigo + ' - ' + insumo.nombre);
                                    if (insumo.unidad) {
                                        displayText = displayText.replace(new RegExp(`\\s*[-–—]\\s*${insumo.unidad}\\s*$`), '');
                                        displayText = displayText.replace(new RegExp(`\\s*\\(${insumo.unidad}\\)\\s*$`), '');
                                    }
                                    return (
                                        <Option key={insumo._id} value={insumo._id}>
                                            {displayText}
                                        </Option>
                                    );
                                })}
                            </SelectItem>
                        </FormItem>
                    </td>
                   <td className="td-border">
                        <FormItem noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                            const insumoId = getFieldValue(['insumos', arrayKey, 'insumoId']);
                            const insumoSeleccionado = this.state.todasInsumos?.find(
                                (insumo) => insumo._id.toString() === insumoId?.toString()
                            );
                            return (
                                <div style={{ fontSize: '14px', textAlign: 'center' , color: '#868585'}}>
                                {insumoSeleccionado?.unidad || '-'}
                                </div>
                            );
                            }}
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "proyectoId"]} required noStyle>
                            <SelectItem sinBorde  noDisabledBackground disabled width="100%" placeholder="Proyecto">
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "precioUnitario"]} noStyle required numberCero>
                            <InputNumberItem sinBorde disabled placeholder="Precio Unitario" dineroDisabled />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "precioUnitarioConImpuestos"]} noStyle required>
                            <InputNumberItem sinBorde disabled placeholder="Precio Unitario con Impuestos" dineroDisabled />
                        </FormItem>
                    </td>
                    <td
                        className="td-border"
                        onDoubleClick={() => {
                            const insumos = this.formRef.current.getFieldValue('insumos');
                            const insumoId = insumos[arrayKey]?.insumoId;
                            const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
                            if (insumoId) this.abrirDisponibilidad(insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', insumos[arrayKey]?.proyectoId);
                        }}
                        onContextMenu={(e) => {
                            e.preventDefault();
                            const insumos = this.formRef.current.getFieldValue('insumos');
                            const insumoId = insumos[arrayKey]?.insumoId;
                            const insumoObj = this.state.todasInsumos?.find(i => i._id.toString() === insumoId?.toString());
                            this.abrirHistorialCliente(insumoId, insumoObj?.nombre || insumoObj?.descripcion || '', arrayKey);
                        }}
                        title="Doble clic: disponibilidad · Clic derecho: historial con este cliente"
                        style={{ cursor: 'pointer' }}
                    >
                        <div style={{ pointerEvents: 'none' }}>
                            <FormItem {...restField} name={[name, "cantidadProyecto"]} required noStyle>
                                <InputNumberItem sinBorde disabled placeholder="Inventario" />
                            </FormItem>
                        </div>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "cantidad"]} number noStyle type="number">
                            <InputNumberItem sinBorde disabled placeholder="Cantidad" />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        <FormItem {...restField} name={[name, "pendiente"]} number noStyle>
                            <InputNumberItem sinBorde disabled placeholder="Pendiente" />
                        </FormItem>
                    </td>
                    <td className="td-border">
                        {this.state.tiposDescuento[arrayKey] === "cantidad" ? (
                            <FormItem
                            {...restField}
                            key={`desc-cantidad-${arrayKey}`}
                            name={[name, "descuentoCantidad"]}
                            numberCero
                            noStyle
                            initialValue={0}
                            >
                            <InputNumberItem
                                disabled
                                sinBorde
                                placeholder="Desc. $"
                                dinero
                                onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                                onChange={(value) =>
                                this.onChangePrecioCantidadDescuento(value, arrayKey)
                                }
                            />
                            </FormItem>
                        ) : (
                            <FormItem
                            {...restField}
                            key={`desc-porcentaje-${arrayKey}`}
                            name={[name, "descuento"]}
                            required
                            numberCero
                            noStyle
                            initialValue={0}
                            >
                            <InputNumberItem
                                disabled
                                sinBorde
                                placeholder="Desc. %"
                                porcentaje
                                max={100}
                                onDoubleClick={() => this.onDobleClickDescuento(arrayKey)}
                                onChange={(value) =>
                                this.onChangePrecioCantidadDescuento(value, arrayKey)
                                }
                            />
                            </FormItem>
                        )}
                        </td>

                     {/* Columna: Subtotal / Impuesto / Total */}
                    <td className="td-border">
                    <FormItem noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                        const subtotal = getFieldValue(['insumos', arrayKey, 'subtotal']) || 0;
                        const impuestos = getFieldValue(['insumos', arrayKey, 'impuestos']) || 0;
                        const total = getFieldValue(['insumos', arrayKey, 'total']) || 0;
        
                        return (
                               <div className="celda-totales" style={{ fontSize: '12px' }}>
                                    <div>{dineroDisabledMask(subtotal)}</div>
                                    <div>{dineroDisabledMask(impuestos)}</div>
                                    <div className="total-bold">Total: {dineroDisabledMask(total)}</div>
                                </div>
                        );
                        }}
                    </FormItem>
        
                    {/* Campos hidden para mantener los valores en el form */}
                    <FormItem {...restField} name={[name, "subtotal"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "impuestos"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    <FormItem {...restField} name={[name, "total"]} required numberCero hidden>
                        <InputNumberItem />
                    </FormItem>
                    </td>
                    <td className="td-border-sin-right">
                        <Row>
                            <Col span={24}>
                            <FormItem noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                    let arrayValue = getFieldValue("insumos");
                                    let mostrarLeyenda = false, mostrarObservaciones = false;
                                    let insumoOriginal;
                                    if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                        const insumo = this.state.todasInsumos.find((v) => v._id === arrayValue[arrayKey].insumoId);
                                        insumoOriginal = insumo;
                                        mostrarLeyenda = insumo?.leyendaVenta;
                                        mostrarObservaciones = insumo?.observacionesVenta;
                                    }
                                    let buttons = [];
                                    if (arrayValue[arrayKey]?.insumoId) {
                                        buttons.push(
                                            <Tooltip key="detalle" title="Ver detalle del insumo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                <ButtonItem type="primary" size="small" cyan icon={<EyeOutlined />} onClick={() => this.abrirDetalleInsumo(arrayValue[arrayKey].insumoId, insumoOriginal?.nombre || insumoOriginal?.descripcion || '')} />
                                            </Tooltip>
                                        );
                                    }
                                    if (mostrarLeyenda && arrayValue[arrayKey]?.leyenda) {
                                        buttons.push(
                                            <Tooltip key="leyenda" title="Ver Leyenda" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                <ButtonItem type="primary" size="small" icon={<FileTextOutlined />} lima2 disabled />
                                            </Tooltip>
                                        );
                                    }
                                    if (textoDescripcionLarga(insumoOriginal) && imprimeDescripcionLarga(arrayValue[arrayKey], insumoOriginal)) {
                                        buttons.push(
                                            <BotonDescripcionLarga key="descripcionLarga" soloLectura renglon={arrayValue[arrayKey]} insumoOriginal={insumoOriginal} />
                                        );
                                    }
                                    if (mostrarObservaciones && arrayValue[arrayKey]?.observaciones) {
                                        buttons.push(
                                            <Tooltip key="observaciones" title="Ver Observaciones" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                                                <ButtonItem type="primary" size="small" cyan2 icon={<CommentOutlined />} disabled />
                                            </Tooltip>
                                        );
                                    }
                                    return (
                                        <div className="acciones-container">
                                            <Space style={{ width: '100%', gap: 5, marginLeft: 8 }} size={4}>
                                                {buttons}
                                            </Space>
                                        </div>
                                    );
                                }}
                            </FormItem>
                        </Col></Row>
                    </td>
                </tr>
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && prev.insumos[arrayKey]?.leyenda !== curr.insumos[arrayKey]?.leyenda}>
                    {({ getFieldValue }) => {
                        let arrayValue = getFieldValue("insumos");
                        if (arrayValue && arrayValue[arrayKey]?.leyenda) {
                            return (<tr className="fila-leyenda"><td colSpan="11" className="td-border"><div className="contenedor-leyenda"><div className="texto-leyenda"><b>Leyenda:</b> {arrayValue[arrayKey].leyenda}</div></div></td></tr>);
                        }
                    }}
                </FormItem>
                <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos && curr.insumos && (prev.insumos[arrayKey]?.observaciones !== curr.insumos[arrayKey]?.observaciones || prev.insumos[arrayKey]?.observacionesXml !== curr.insumos[arrayKey]?.observacionesXml)}>
                    {({ getFieldValue }) => {
                        let arrayValue = getFieldValue("insumos");
                        if (arrayValue && arrayValue[arrayKey]?.observaciones) {
                            return (<tr className="fila-observaciones"><td colSpan="11" className="td-border-sin-right"><div style={{ display: 'flex', justifyContent: 'left', alignItems: 'left', backgroundColor: arrayValue[arrayKey].observacionesXml ? '#dceeffff' : 'white' }}><div style={{ width: '100%', textAlign: 'left', paddingLeft: 25, color: "#005661" }}>{String(arrayValue[arrayKey].observaciones).split(/\r?\n/).map((line, i) => <span key={i}>{line}<br /></span>)}</div></div></td></tr>);
                        }
                    }}
                </FormItem>
            </React.Fragment>
        );
    }

    // Método para obtener configuración de checkboxes
    getCheckboxesConfig() {
        const checkboxes = [];

        if (this.props.quitarImpuestosOpcionalVentas) {
            checkboxes.push({ label: "Quitar Impuestos", name: "quitarImpuestos", disabled: true });
        }

        checkboxes.push({
            label: "Imprimir",
            name: "imprimirObservaciones",
            disabled: true
        });

        checkboxes.push({
            label: "Des. Imprimir Banco",
            name: "deshabilitarBanco",
            disabled: true
        });

        return checkboxes;
    }

    getObservacionesConfig() {
        return {
            observaciones: {
                label: "Observaciones",
                value: this.formRef.current?.getFieldValue("observaciones") || "",
                disabled: true
            },
            observaciones2: {
                label: "Observaciones Internas",
                value: this.formRef.current?.getFieldValue("observaciones2") || "",
                tooltip: "Estas observaciones no se imprimirán.",
                disabled: true
            },
            checkboxes: this.getCheckboxesConfig(),
              totales: (
                <table className="table" style={{ marginTop: 0 }}>
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ width: "50%", fontSize: "16px" }}>
                                Total Insumos
                            </th>
                            <td className="td-totales-right" style={{ width: "50%", fontSize: "16px" }}>
                                {this.state.totalCantidadInsumos}
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <th className="th-totales" style={{ width: "50%" }}>Subtotal</th>
                            <td className="td-totales-right" style={{ width: "50%" }}>{dineroDisabledMask(this.state.subtotal)}</td>
                        </tr>
                    </tbody>
                    {this.state.arrayImpuestos.map((valueArray) => (
                        <tbody key={valueArray.descripcionFactura}>
                            <tr>
                                <th className="th-totales">{valueArray.descripcionFactura}</th>
                                <td className="td-totales-right">{dineroDisabledMask(valueArray.totalImpuestos)}</td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales">Total</th>
                            <td className="td-totales-right">{dineroDisabledMask(this.state.total)}</td>
                        </tr>
                    </tbody>
                    {this.state.arrayRetenciones.map((value) => (
                        <tbody key={value.descripcionFactura}>
                            <tr>
                                <th className="th-totales">{value.descripcionFactura}</th>
                                <td className="td-totales-right">{dineroDisabledMask(value.totalRetenciones)}</td>
                            </tr>
                        </tbody>
                    ))}
                    <tbody>
                        <tr>
                            <th className="th-totales">Total a Pagar</th>
                            <td className="td-totales-right">{dineroDisabledMask(this.state.totalPagar)}</td>
                        </tr>
                    </tbody>
                </table>
            )
    };
  }

    render() {
        const isMobile = window.innerWidth <= 1000;
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title={`Ver Embarque ( ${this.state.numeroEmbarque} )`}
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={(
                        <TrazabilidadSteps trace={this.state.trace} />
                    )}
                />
                <div className="card-background" style={{ paddingTop: 0 }}>
                    <Spin
                        spinning={this.state.loading}
                        style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                        <Form
                            ref={this.formRef}
                            name="VerPedido"
                            layout
                            onFinish={(values) =>
                                this.setState({ modalConfirmacion: true, valuesForm: values })
                            }
                            onFinishFailed={this.onFinishFailed}
                        >
                            <FormItem noStyle shouldUpdate={(prev, curr) => prev.contado !== curr.contado || prev.factura !== curr.factura}>
                                {({ getFieldValue }) => {
                                    const contado = getFieldValue("contado");
                                    const factura = getFieldValue("factura");
                                    const showFormaDePago = factura === 1 || contado !== 1;
                                    return (
                            <VentasForm
                                totalPagar={this.state.totalPagar || 0}
                                showDoctor={this.props.equipoMedico}
                                showRegimenFiscal={false}
                                showMoneda={true}
                                showFormaDePago={showFormaDePago}
                                datosGeneralesCol={{ xs: 24, sm: 24, md: 24, lg: 18, xl: 18 }}
                                monedaCol={{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }}

                                datosGeneralesContent={(
                                    <>
                                     <Row gutter={[16, 8]} align="middle">
                                        <Col xs={24} sm={24} md={14} lg={14}>
                                            <FormItem label="Cliente" name="clienteId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 18}}>
                                                <SelectClientesItem
                                                    empresaId={this.props.empresaId}
                                                    headersToken={this.props.headersToken}
                                                    sinBorde
                                                    disabled
                                                    dropdownMatchSelectWidth={600}
                                                    width="100%"
                                                    placeholder="Cliente"
                                                    noDisabledBackground
                                                />
                                            </FormItem>
                                        </Col>
                                       
                                         <Col xs={12} sm={8} md={10} lg={10}>
                                            <FormItem label="Fecha" name="fechaPedido" required margin labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                                                <DatePickerItem disabled placeholder="Fecha" allowClear={false} />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                     <Row gutter={[16, 8]} align="middle">
                                         <Col xs={24} sm={24} md={14} lg={14}>
                                            <FormItem label="Vendedor" name="vendedorId" margin required labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                                <SelectItem disabled  noDisabledBackground placeholder="Vendedor">{this.state.objetoUsuarios}</SelectItem>
                                            </FormItem>
                                        </Col>
                                          <Col xs={12} sm={8} md={10} lg={10}>
                                            <FormItem required initialValue={1} name="contado" label="Método" labelCol={{ span: 8 }} wrapperCol={{ span: 12 }} margin>
                                                <SelectItem width="100%" disabled  noDisabledBackground>
                                                    <Option value={1}>Contado - PUE</Option>
                                                    <Option value={2}>Crédito - PPD</Option>
                                                </SelectItem>
                                            </FormItem>
                                          </Col>
                                      </Row>
                                    
                                    </>                                    
                                )}
                                datosClienteContent={(
                                    <Row gutter={[16, 8]}>
                                        <Col span={24}><FormItem name="ordenDeCompra" label="O Compra" pattern margin labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><InputItem disabled placeholder="Orden de Compra" /></FormItem></Col>
                                        <Col span={24}><FormItem name="req" label="Req" pattern margin labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><InputItem disabled placeholder="Requisición" /></FormItem></Col>
                                        <Col span={24}><FormItem pattern name="atencion" label="Atención a" margin tooltip="Indica a quién dirigir este documento." labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><InputItem disabled placeholder="Atención a" /></FormItem></Col>
                                    </Row>
                                )}
                                extrasContent={(
                                    <Row gutter={[16, 8]}>
                                        <Col span={24}>
                                            <FormItem
                                                name="fechaEntregaEstimada"
                                                label="F. Entrega Est."
                                                margin
                                                labelCol={{ span: 8 }}
                                                wrapperCol={{ span: 14 }}
                                            >
                                                <DatePickerItem disabled placeholder="Fecha de entrega estimada" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                )}
                                doctorContent={this.props.equipoMedico ? (
                                    <Row gutter={[8, 8]}>
                                        <Col xs={24} sm={24} md={24} lg={24} span={24}>
                                        <FormItem name="doctorId" label="Doctor:" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin>
                                            <SelectItem disabled  noDisabledBackground placeholder="Doctor">{this.state.objetoDoctores}</SelectItem>
                                            </FormItem>
                                            </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} span={24}><FormItem name="pacienteId" label="Paciente:" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin>
                                            <SelectItem disabled noDisabledBackground placeholder="Paciente">{this.state.objetoPacientes}</SelectItem>
                                            </FormItem>
                                            </Col>
                                        <Col xs={24} sm={24} md={24} lg={24} span={24}><FormItem name="cirugiaId" label="Cirugía:" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }} margin>
                                            <SelectItem disabled noDisabledBackground placeholder="Cirugia">{this.state.objetoCirugias}</SelectItem>
                                            </FormItem>
                                            </Col>
                                    </Row>
                                ) : null}
                                monedaContent={(
                                    <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId}>
                                        {({ getFieldValue }) => {
                                            const monedaId = getFieldValue('monedaId');
                                            return (
                                                <>
                                                    <FormItem required margin name="monedaId" label="Moneda" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                        <SelectItem  noDisabledBackground disabled placeholder="Moneda">{this.state.objetoMonedas}</SelectItem>
                                                    </FormItem>
                                                    {monedaId !== '60c7e4396465ad440c41c15a' ? (
                                                        <FormItem required number margin label="T. Cambio" name="tipoDeCambio" type="number" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
                                                            <InputNumberItem disabled dinero placeholder="T. Cambio" />
                                                        </FormItem>
                                                    ) : (
                                                        <FormItem name="tipoDeCambio" initialValue={1} hidden><InputNumberItem /></FormItem>
                                                    )}
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                )}
                                datosVentaContent={(
                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                            return (
                                                <>
                                                    <Col span={24}><FormItem label="Proyecto" name="proyectoId" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><SelectItem disabled placeholder="Proyecto">{this.state.objetoProyectos}</SelectItem></FormItem></Col>
                                                    <Col span={24}><FormItem name="precioId" label="Precio" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><SelectItem disabled placeholder="Precio">{this.state.objetoPrecios}</SelectItem></FormItem></Col>
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                )}
                                formaDePagoContent={(
                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) => {
                                            const contado = getFieldValue("contado");
                                            const factura = getFieldValue("factura");
                                            const usoCFDI = factura === 1 ? (
                                                <Col span={24}><FormItem name="usoDeCfdiId" label="Uso CFDI" margin required labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><SelectItem disabled placeholder="Uso de CFDI">{this.state.objetoUsosDeCFDI}</SelectItem></FormItem></Col>
                                            ) : null;
                                            const diasCredito = contado !== 1 ? (
                                                <Col span={24}><FormItem label="Días de crédito" name="diasCredito" numberCero margin required initialValue={0} labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}><InputNumberItem disabled placeholder="Días de Crédito" /></FormItem></Col>
                                            ) : null;
                                            if (!usoCFDI && !diasCredito) return null;
                                            return (
                                                <Row gutter={[6, 4]}>
                                                    {usoCFDI}
                                                    {diasCredito}
                                                </Row>
                                            );
                                        }}
                                    </FormItem>
                                )}
                                tabs={[{
                                    key: "insumos",
                                    label: "Insumos",
                                    listName: "insumos",
                                    columns: this.getInsumosColumns(),
                                    renderRow: this.renderInsumoRow.bind(this)
                                }, {
                                    key: "entrega",
                                    label: "Entrega",
                                    forceRender: true,
                                    customContent: <TabEntregaDireccion
                                        key={`direccion-${this.state.direccionesCliente?.[0]?._id || 'no-cliente'}`}
                                        readOnly={true}
                                        direccionEntrega={this.formRef.current?.getFieldValue("direccionEntrega")}
                                        clienteDireccion={this.state.direccionesCliente?.[0]}
                                        loadingEntrega={this.state.loadingEntrega}
                                        formInstance={this.formRef.current}
                                        objetoMunicipios={this.state.objetoMunicipios}
                                        objetoEstados={this.state.objetoEstados}
                                        objetoPaises={this.state.objetoPaises}
                                        objetoPlantasEntrega={this.state.objetoPlantasEntrega}
                                    />
                                }].filter(Boolean)}
                                defaultActiveKey="insumos"
                                onTabChange={(key) => {
                                    if (key === "entrega") this.consultarInformacionEntrega();
                                    return this.setState({ activeTabKey: key });
                                }}
                                isMobile={isMobile}
                                formInstance={this.formRef.current}
                                observacionesConfig={this.getObservacionesConfig()}
                                
                                actionButtons={(
                                    <>
                                      {this.state.estado !== 0 && !this.state.requerido ?
                                            <ButtonItem
                                                type="primary"
                                                blanco
                                                icon={<IconAd2 />}
                                                disabled
                                                onClick={this.requerirInsumos.bind(this)}
                                            >
                                                Requerir Insumos
                                            </ButtonItem>
                                            : null}
                                        {this.state.estado !== 0 && this.state.requerido ?
                                            <ButtonItem
                                                type="primary"
                                                cafeB
                                                icon={<IconAd2 />}  
                                                onClick={() => this.setState({ modalRastrearRequisicion: true })}
                                            >
                                                Rastrear Requisicion
                                            </ButtonItem>
                                            : null}
                                        {this.state.estado === 1 && this.props.permisoApartarInsumosPedido ?
                                            <ButtonItem
                                                type="primary"
                                                naranjaB
                                                icon={<IconAd2 />}
                                                disabled
                                                onClick={this.apartarInsumos.bind(this)}
                                            >
                                                Apartar Insumos
                                            </ButtonItem>
                                            : null}
                                        {this.state.apartado && this.state.estado !== 0 ?
                                            <ButtonItem
                                                type="primary"
                                                verdeB
                                                icon={<IconAd2 />}
                                                disabled
                                            >
                                                Quitar Apartado
                                            </ButtonItem>
                                            : null}
                                        {this.props.permisoGenerarVentasEmbarques && this.state.estado === 1 ?
                                            <ButtonItem
                                                type="primary"
                                                  hotkey="shift+v"
                                                onClick={() => this.generarVentaDePedido()}
                                                cyanB
                                            >
                                                Generar Venta
                                            </ButtonItem>
                                            : null}
                                        {(this.state.estado === 1 && this.state.anticipos) ?
                                            <ButtonItem
                                                type="primary"
                                                onClick={() => this.generarAnticipo()}
                                                ambarB
                                                hotkey="shift+a"
                                            >
                                                Generar Anticipo
                                            </ButtonItem>
                                            : null}
                                        {this.state.estado !== 0 && this.state.estado !== 3 ?
                                            <Popconfirm
                                                title={'Seguro que quiere cancelar este embarque'}
                                                onConfirm={() => this.cancelarEmbarque(this.state.id)}
                                                okText="Ok"
                                                cancelText="Cancelar"
                                            >
                                                <ButtonItem
                                                    type="default"
                                                    size="small"
                                                    hotkey="shift+c"
                                                    rojoB
                                                >
                                                    Cancelar
                                                </ButtonItem>
                                            </Popconfirm>
                                            : null}
                                        <ButtonItem
                                            type="primary"
                                            hotkey="shift+m"
                                            blanco
                                            icon={<SendOutlined />}
                                            onClick={() => this.enviarPedido(this.state.id)}
                                        >
                                            Mandar Correo
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            verdeB
                                            icon={<FileExcelOutlined />}
                                            loading={this.state.descargandoExcel}
                                            onClick={this.descargarExcel.bind(this)}
                                        >
                                            Descargar Excel
                                        </ButtonItem>
                                        <ButtonItem
                                            type="primary"
                                            hotkey="shift+r"
                                            rojoB
                                            onClick={this.atras.bind(this)}
                                        >
                                            Regresar
                                        </ButtonItem>
                                    </>
                                )}
                            />
                                    );
                                }}
                            </FormItem>
                        </Form>
                    </Spin>
                </div>
                <ModalItem
                    title="Confirmacion"
                    visible={this.state.modalConfirmacion}
                    onCancel={() => this.setState({ modalConfirmacion: false })}
                    onOk={() => {
                        this.setState({ modalConfirmacion: false });
                        this.onFinish(this.state.valuesForm);
                    }}
                    spinning={false}
                    footer
                >
                    <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
                </ModalItem>
                <MandarCorreoEmbarque
                    visible={this.state.modalCorreo}
                    id={this.state.modalCorreoId}
                    cerrarMandarCorreoEmbarque={this.cerrarMandarCorreoEmbarque.bind(this)}
                />
                <GenerarVentaDeEmbarque
                    visible={this.state.modalGenerarVenta}
                    id={this.state.id}
                    cerrarGenerarVentaDeEmbarque={this.cerrarGenerarVentaDeEmbarque.bind(this)}
                />
                <RastrearRequisicion
                    pedido={true}
                    visible={this.state.modalRastrearRequisicion}
                    id={this.state.id}
                    cerrarRastrearRequisicion={this.cerrarRastrearRequisicion.bind(this)}
                />
                <DetalleInsumoModal
                    visible={this.state.modalDetalleInsumoVisible}
                    onClose={this.cerrarDetalleInsumo}
                    insumoId={this.state.insumoSeleccionadoDetalle.id}
                    nombreInsumo={this.state.insumoSeleccionadoDetalle.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
                <DisponibilidadInsumoModal
                    visible={this.state.modalDisponibilidadVisible}
                    onClose={this.cerrarDisponibilidad.bind(this)}
                    insumoId={this.state.insumoSeleccionadoDisponibilidad.id}
                    nombreInsumo={this.state.insumoSeleccionadoDisponibilidad.nombre}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                    proyectoId={this.state.insumoSeleccionadoDisponibilidad.proyectoId}
                />
                <HistorialInsumoClienteModal
                    visible={this.state.modalHistorialClienteVisible}
                    onClose={this.cerrarHistorialCliente}
                    insumoId={this.state.insumoSeleccionadoHistorial.id}
                    nombreInsumo={this.state.insumoSeleccionadoHistorial.nombre}
                    clienteId={this.state.insumoSeleccionadoHistorial.clienteId}
                    excluirId={this.state.id}
                    headersToken={this.props.headersToken}
                    empresaId={this.props.empresaId}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.usuarioId,
        certificada: state.empresa.certificada,
        complementoDetallista: state.empresa.complementoDetallista,
        equipoMedico: state.empresa.equipoMedico,
        permisoFacturarVentas:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "615ce36bf30e81b54183cfaf"
            )?.activado,
        permisoApartarInsumosPedido:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "68e49edf75bb93249195301f"
            )?.activado,
        permisoGenerarVentasEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "689fd5bb7ec315a681480e9c"
            )?.activado,
        quitarImpuestosOpcionalVentas: state.empresa.quitarImpuestosOpcionalVentas,
    };
};

export default connect(mapStateToProps)(VerEmbarque);
